import { useEffect, useRef } from 'react';
import { useApi, oauthRequestApiRef } from '@backstage/core-plugin-api';

/**
 * A replacement for OAuthRequestDialog that auto-triggers OAuth requests
 * instead of showing a modal dialog. This provides a seamless login experience.
 */
export const AutoTriggerOAuthDialog = () => {
  const oauthRequestApi = useApi(oauthRequestApiRef);
  const triggeredRequestsRef = useRef<Set<string>>(new Set());

  useEffect(() => {
    const subscription = oauthRequestApi.authRequest$().subscribe(requests => {
      requests.forEach(request => {
        const requestKey = request.provider.title;

        // Only trigger each request once
        if (!triggeredRequestsRef.current.has(requestKey)) {
          triggeredRequestsRef.current.add(requestKey);

          request.trigger().catch(() => {
            // Remove from triggered set so it can be retried
            triggeredRequestsRef.current.delete(requestKey);
          });
        }
      });

      // Clean up triggered requests that are no longer pending
      const currentProviders = new Set(requests.map(r => r.provider.title));
      triggeredRequestsRef.current.forEach(key => {
        if (!currentProviders.has(key)) {
          triggeredRequestsRef.current.delete(key);
        }
      });
    });

    return () => subscription.unsubscribe();
  }, [oauthRequestApi]);

  // This component doesn't render anything
  return null;
};
